import axios from 'axios'
import { Commit } from 'vuex'

const url_api3 = process.env.VUE_APP_API_URL_3

export default {
    namespaced: true,
    state: {
        listDonasi: [],
        editDonasi: null,
        deleteDonasi: null,
        createDonasi: null,
    },
    getters: {
        getListDonasi: (state: { listDonasi: any[] }) => state.listDonasi,
    },
    mutations: {
        SET_LIST_DONASI(state: { listDonasi: any[] }, payload: any[]) {
            state.listDonasi = payload;
        },
        SET_EDIT_DONASI(state: { editDonasi: any[] }, payload: any[]) {
            state.editDonasi = payload;
        },
        SET_DELETE_DONASI(state: { deleteDonasi: any[] }, payload: any[]) {
            state.deleteDonasi = payload;
        },
        SET_CREATE_DONASI(state: { createDonasi: any[] }, payload: any[]) {
            state.createDonasi = payload;
        },
    },
    actions: {
        async listDonasi({ commit }: { commit: Commit }, payload: { index: number; limit: number }) {
            const { index, limit } = payload
            try {
                await axios.get(url_api3 + "donasi",
                    {
                        params: {
                            index: index,
                            limit: limit
                        },
                        headers: {
                            "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                        }
                    }
                )
                    .then((response) => {
                        commit('SET_LIST_DONASI', response.data)
                        console.log(response)
                    })
            } catch (error) {
                return error
            }
        },
        async editDonasi({ commit }: { commit: Commit }, payload: { id: string; name: string; description: string; target: number; accumulated: number; thumbnail: string; image: string; category: string; qris: string }) {
            const { id, name, description, target, accumulated, thumbnail, image, category, qris } = payload

            try {
                await axios.put(url_api3 + "donasi/update",
                    {
                        name,
                        description,
                        target,
                        accumulated,
                        thumbnail,
                        image,
                        category,
                        qris
                    },
                    {
                        params: {
                            id: id,
                        },
                        headers: {
                            "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                        }
                    }
                )
                    .then((response) => {
                        commit('SET_EDIT_DONASI', response.data)
                        console.log(response)
                    })
            } catch (error) {
                return error
            }
        },
        async deleteDonasi({ commit }: { commit: Commit }, payload: { id: string }) {
            const { id } = payload
            try {
                await axios.delete(url_api3 + "donasi/delete",
                    {
                        data: {
                            id: id
                        },
                        headers: {
                            "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                        }
                    }
                )
                    .then((response) => {
                        commit('SET_DELETE_DONASI', response.data)
                        console.log(response)
                    })
            } catch (error) {
                return error
            }
        },
        async createDonasi({ commit }: { commit: Commit }, payload: { name: string; description: string; target: number; accumulated: number; thumbnail: string; image: string; category: string; qris: string }) {
            const { name, description, target, accumulated, thumbnail, image, category, qris } = payload

            try {
                await axios.post(url_api3 + "donasi",
                    {
                        name,
                        description,
                        target,
                        accumulated,
                        thumbnail,
                        image,
                        category,
                        qris
                    },
                    {
                        headers: {
                            "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                        }
                    }
                )
                    .then((response) => {
                        commit('SET_CREATE_DONASI', response.data)
                        console.log(response)
                    })
            } catch (error) {
                return error
            }
        },
    },
}